import axios from 'axios'

export const shouldRetry = (err: unknown) => {
  if (!axios.isAxiosError(err)) return false

  const status = err.response?.status

  // 429 = rate limit
  // 502/503/504 = transitoire
  return status === 429 || status === 502 || status === 503 || status === 504
}
